import { useCallback, useMemo, useState } from 'react';
export function useBoolean(initial) {
    const [value, setValue] = useState(initial);
    const toggle = useCallback(() => setValue((v) => !v), []);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const actions = useMemo(() => ({ setValue, toggle, setTrue, setFalse }), [setFalse, setTrue, toggle]);
    return useMemo(() => [value, actions], [actions, value]);
}
export default useBoolean;
//# sourceMappingURL=useBoolean.js.map